import ChiefComplaintMixin from '@/Mixins/BaseInformation/ChiefComplaintMixin';
export default {
  mixins: [ChiefComplaintMixin],
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      this.getListOfChiefComplaintsForOther();
    },
  },
};
